import { useSearchParams } from 'react-router-dom';

import SimulationBanner from './simulation-banner';
import StatusLegend from './status-legend';
import TeamBlock from './team-block';
import PageHeader from '../../../common/components/page-header/page-header';
import EmptyState from '../../../common/components/state-message/empty-state';
import ErrorState from '../../../common/components/state-message/error-state';
import LoadingState from '../../../common/components/state-message/loading-state';
import { useProjectCatalog } from '../../../global/contexts/catalogs/catalogs';
import { useSeats } from '../../../global/contexts/coordination/coordination';
import { useSimulation } from '../contexts/simulation';
import { useTeamsList } from '../contexts/teams';
import { countByStatus, STATUS_SEQUENCE, toAgent } from '../utils/agents';

import '../styles/overview.css';

export default function TeamsOverview() {
    const [params, setParams] = useSearchParams();
    const rawStatus = params.get('status') || '';
    const statusFilter = STATUS_SEQUENCE.includes(rawStatus) ? rawStatus : '';
    const teamsQuery = useTeamsList();
    const seatsQuery = useSeats();
    const { data: projects } = useProjectCatalog();
    const { overrides } = useSimulation();

    const seats = seatsQuery.data?.items ?? [];
    const counts = countByStatus(seats.map((seat) => toAgent(seat, overrides)));

    const setStatus = (value) => {
        const next = new URLSearchParams(params);
        if (value) next.set('status', value);
        else next.delete('status');
        setParams(next, { replace: true });
    };

    const isPending = teamsQuery.isPending || seatsQuery.isPending;
    const error = teamsQuery.error || seatsQuery.error;
    const teams = teamsQuery.data?.items ?? [];

    return (
        <div className="teams-overview">
            <PageHeader
                eyebrow="Coordinación"
                title="Equipos"
                description="Cada equipo con sus proyectos y los agentes de sus integrantes: qué hacen ahora y cuándo dieron señal por última vez."
            />
            <StatusLegend counts={counts} value={statusFilter} onChange={setStatus} />
            <SimulationBanner />

            {isPending && <LoadingState label="Cargando equipos" rows={3} />}
            {error && !isPending && (
                <ErrorState
                    error={error}
                    onRetry={() => {
                        teamsQuery.refetch();
                        seatsQuery.refetch();
                    }}
                />
            )}
            {!isPending && !error && teams.length === 0 && <EmptyState title="No hay equipos visibles" />}
            {!isPending && !error && teams.length > 0 && (
                <div className="teams-overview__list">
                    {teams.map((team) => (
                        <TeamBlock key={team.id} team={team} seats={seats} projects={projects} statusFilter={statusFilter} />
                    ))}
                </div>
            )}
        </div>
    );
}
